import { React, useCallback, useRef, useState } from 'react';
import Layout from '../Layout';
import { useParams } from 'react-router-dom';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import ChatBotHeader from './ChatBotHeader';
import { useSocket } from '../../Context/SocketContext';
import { useEffect } from 'react';
import { SearchBar } from '../Search';
import ClassGrid from './ClassGrid';

import { MultiturnChat } from '../Helpers/MultiturnChat';
import { packageClasses } from '../Constants';
import { useAuth } from '../../Context/AuthContext';

const ClassChat = () => {
  const { name } = useParams();
  const [menuBtnText, setMenuBtnText] = useState('Select Difficulty Level');
  const [filteredText, setFilteredText] = useState('');

  const [isloading, setIsLoading] = useState(true);

  const [classes, setClasses] = useState([...packageClasses]);
  const [filteredClass, setFilteredClass] = useState([...packageClasses]);

  const socket = useSocket();
  const { setTopLevelError } = useAuth();

  const handleMenuBtnText = selectedOption => {
    setMenuBtnText(selectedOption);
  };

  const bodyRenderer = useCallback(
    () => <MultiturnChat menuBtnText={menuBtnText} />,
    [menuBtnText]
  );

  const gridHeaderRenderer = useCallback(
    () => (
      <>
        <Text fontSize="34px" color="#1b254b" fontWeight="700">
          Class Chatbots
        </Text>
        <SearchBar
          mt="8px"
          maxWidth="300px"
          setFilteredText={setFilteredText}
        />

        <Text
          color="var(--chakra-colors-gray-500)"
          fontWeight="500"
          fontSize="var(--chakra-fontSizes-sm)"
          textAlign="center"
          pt="20px"
        >
          Class Chatbots
        </Text>
      </>
    ),
    []
  );

  const gridBodyRenderer = useCallback(() => {
    return (
      <ClassGrid
        classes={classes}
        setClasses={setClasses}
        filteredClass={filteredClass}
        isloading={isloading}
      />
    );
  }, [classes, filteredClass, isloading]);

  useEffect(() => {
    const filtered = classes.filter(cls =>
      cls.toLowerCase().includes(filteredText.toLowerCase())
    );

    setFilteredClass(filtered);
  }, [filteredText, classes]);

  useEffect(() => {
    if (!socket) return;

    socket.emit('retrieveClass');

    socket.on('retrieveClass', data => {
      const { success, response } = data;
      if (success) {
        setClasses(prev => Array.from(new Set([...prev, ...response])));
      } else {
        setTopLevelError('Something went wrong! Please refresh and try again');
      }

      // setClasses(prev => Array.from(new Set([...prev, ...data])));
      setIsLoading(false);
    });

    return () => {
      socket.off('retrieveClass');
    };
  }, [socket, setTopLevelError]);

  return (
    <>
      {name ? (
        <Layout
          header={() => (
            <ChatBotHeader
              name={name}
              menuBtnText={menuBtnText}
              handleMenuBtnText={handleMenuBtnText}
            />
          )}
          // body={renderBody}
          body={bodyRenderer}
          hasGenericFooter={true}
        />
      ) : (
        <Layout
          header={gridHeaderRenderer}
          body={gridBodyRenderer}
          hasGenericFooter={true}
          showBackgroundImage={true}
        />
      )}
    </>
  );
};

export default ClassChat;

// <Grid
// templateAreas={`"header"
//             "main"
//             "footer"`}
// gridTemplateRows={'200px 1fr 90px'}
// gridTemplateColumns={'1fr'}
// h="100vh"
// gap="1"
// color="blackAlpha.700"
// fontWeight="bold"
// >
// <GridItem gridArea="header" bg="white" color="black" pt="50px">
//   <Text fontSize="34px" color="#1b254b" fontWeight="700">
//     Class Chatbots
//   </Text>
//   <SearchBar mt="8px" maxWidth="300px" />

//   <Text
//     color="var(--chakra-colors-gray-500)"
//     fontWeight="500"
//     fontSize="var(--chakra-fontSizes-sm)"
//     textAlign="center"
//     pt="20px"
//   >
//     Class Chatbots
//   </Text>
// </GridItem>

// <GridItem
//   gridArea="main"
//   bg="white"
//   overflowY={{ base: 'none', xl: 'auto', lg: 'auto' }}
//   sx={{
//     '&::-webkit-scrollbar': {
//       width: '10px', // Width of the scrollbar
//     },
//     '&::-webkit-scrollbar-thumb': {
//       backgroundColor: '#888', // Color of the scrollbar handle
//       borderRadius: '5px', // Rounded corners
//     },
//     '&::-webkit-scrollbar-track': {
//       backgroundColor: '#f1f1f1', // Color of the scrollbar track
//     },
//     '&::-webkit-scrollbar-thumb:hover': {
//       backgroundColor: '#555', // Darker color when hovered
//     },
//   }}
// >
//   <SimpleGrid minChildWidth="220px" spacing="40px" padding="10px">
//     {classes.map(cls => (
//       <ClassChatCard name={cls} />
//     ))}
//   </SimpleGrid>
// </GridItem>

// <GridItem gridArea="footer" bg="white">
//   footer
// </GridItem>
// </Grid>
